<template>
  <MainLayout>
    <Head>
      <title>{{ option.name }} :: Attributes</title>
    </Head>
    <template v-slot:header>
      {{ option.name }} :: Attributes
    </template>

    <div class="mb-4" v-if="$can('options.write')">
      <ButtonGroup>
        <button type="button" @click="addNew">Add Attribute</button>
      </ButtonGroup>
    </div>

    <form @submit.prevent="submit">
      <DataTable>
        <template v-slot:header>
          <th scope="col">Value</th>
          <th v-if="option.has_image" scope="col">Image</th>
          <th scope="col" class="w-2/12">
            <span class="sr-only">Edit</span>
          </th>
        </template>

        <tr v-for="(item, index) in form"
            :key="`${item.id || item.tmp_id}_${version}`">
          <td>
            <FormInput :name="`options.${index}.value`"
                       :show-label="false"
                       :errors="errors"
                       v-model="form[index].value" />
          </td>
          <td v-if="option.has_image"
              class="flex gap-2 items-center">
            <FormInput :name="`options.${index}.image`"
                       :show-label="false"
                       placeholder="Image URL"
                       :errors="errors"
                       v-model="form[index].image"
                       class="flex-1"/>
          </td>
          <td>
            <div class="grid grid-cols-3 gap-0 place-items-end">
              <button type="button"
                      v-if="item.builds_count"
                      :title="`Changes in this attribute will update ${item.builds_count} builds`">
                <TruckIcon class="w-4 h-4" />
              </button>
              <div v-if="! item.builds_count"></div>
              <div>
                <button @click="move(index, -1)" v-show="index" type="button">
                  <ArrowSmUpIcon class="w-4 h-4 inline-block" />
                </button>
                <button @click="move(index, 1)" v-show="index + 1 != form.length" type="button">
                  <ArrowSmDownIcon class="w-4 h-4 inline-block" />
                </button>
              </div>
              <div>
                <button class="ml-4 text-red-600 hover:text-red-900"
                        type="button"
                        v-if="$can('options.write')"
                        @click="removeValue(index)">Delete</button>
              </div>
            </div>
          </td>
        </tr>

        <template v-slot:footer>
          <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
            <FormActions :cancelUrl="$route('options.index')"
                         :show-submit="$can('options.write')"
                         class="-mt-5" />
          </div>
        </template>
      </DataTable>
    </form>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import DataTable from '@/components/data-table.vue'
import {
  ArrowSmUpIcon,
  ArrowSmDownIcon,
} from '@heroicons/vue/solid'
import { TruckIcon } from '@heroicons/vue/outline'
import { nanoid } from 'nanoid'
import { Inertia } from '@inertiajs/inertia'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  components: {
    DataTable,
    ArrowSmUpIcon,
    ArrowSmDownIcon,
    TruckIcon,
  },

  props: {
    option: Object,
    values: Array,
    errors: Object,
  },

  data() {
    return {
      form: [...this.values],
      version: 1,
    }
  },

  methods: {
    move(index, change) {
      const swapIndex = index + change

      this.swapPlaces(this.form, index, swapIndex)
    },

    swapPlaces(what, index, swapIndex) {
      const item = what[index]
      const swapWith = what[swapIndex]

      what.splice(index, 1, swapWith)
      what.splice(swapIndex, 1, item)
    },

    addNew() {
      this.form.push({
        tmp_id: nanoid(),
        value: null,
        image: null,
      })
    },

    submit() {
      const form = {
        options: this.form.map((item, index) => ({
          ...item,
          sort_order: index,
        }))
      }
      Inertia.post(this.$route('options.attributes', [this.option.id]), form, {
        preserveState: false,
      })
    },

    removeValue(index) {
      if (confirm('Are you sure?')) {
        this.form.splice(index, 1)
      }
    }
  },
}
</script>
